// extracted by mini-css-extract-plugin
export default {"page":"Rules_page__NSQkI","panel":"Rules_panel__U+LDD"};